<!--***********************************SECCION DE LOS MODAL******************************************-->
<div id="modalNotas" class="div-modal-dialog">
    <!-- Modal content -->
    <div>
        <div>
            <div class="div-boton-cerrar-dialog"><button mat-button mat-dialog-close (click)="closeDialog()" class = "botonCerrarX">X</button>
            </div>
            <div>
                <h1 class="metadata-titulo">{{tituloNotaFeErrata}}</h1>
            </div>
        </div>
        <img *ngIf="cargando" class="img-load-info" src="/estadisticas-economicas/assets/img/cargando_info.gif" alt="ícono cargando" title="cargando">
        <div id="accordion" class="opcion-menu-accordion ui-accordion ui-widget ui-helper-reset" role="tablist">
            <cdk-accordion class="accordion-container">
                <cdk-accordion-item *ngFor="let metodo of listaMetodologia; let index=index;"
                    #accordionItem="cdkAccordionItem" role="button" tabindex="0" [attr.id]="'accordion-header-' + index"
                    expanded="true" [attr.aria-expanded]="accordionItem.expanded"
                    [attr.aria-controls]="'accordion-body-' + index">
                    <div class="accordion-item-header {{accordionItem.expanded ? 'is-active' : 'not-active'}}"
                        (click)="accordionItem.toggle()">
                        {{ metodo.titulo }}
                        <mat-icon *ngIf="!accordionItem.expanded" class="mat-icon-add">add</mat-icon>
                        <mat-icon *ngIf="accordionItem.expanded" class="mat-icon-remove">remove</mat-icon>
                    </div>
                    <div role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
                        [attr.id]="'accordion-body-' + index" [attr.aria-labelledby]="'accordion-header-' + index">
                        <div role="region" class="div-notas">
                            <ul *ngIf="tipoVisualizacion ==='DOCUMENTOS_METODOLOGICOS'" class="ul-lista-enlace-guia">
                                <li *ngFor="let nota of metodo.lista" class="li-lista-enlace-guia">
                                    <span *ngIf="metodo.tipo === 'NOTAS_FE_ERRATAS'"
                                        class="texto-informacion-nota">{{nota}}</span>
                                    <a *ngIf="metodo.tipo === 'METODOLOGIAS'" (click)="abrirEnlace(nota.nombreAdjunto)"
                                        class="a-link-download-file">
                                        {{nota.descripcion}} </a>
                                </li>
                            </ul>
                            <ul *ngIf="tipoVisualizacion ==='NOTA_ACLARATORIA'" class="ul-lista-enlace-guia">
                                <div *ngFor="let metodo of metodo.lista">
                                    <li><b class="texto-informacion-titulo">{{metodo.titulo}}</b><br>
                                        <div *ngFor="let nota of metodo.lista">
                                            <ul [innerHTML]="nota"></ul>
                                        </div>
                                        <div *ngIf="metodo.lista.length <= 0">
                                            <ul>
                                                <li class="li-lista-enlace-guia">Sin notas</li>
                                             </ul>   
                                            <br>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </cdk-accordion-item>
            </cdk-accordion>
        </div>
    </div>
    <button mat-button mat-dialog-close class = "botonCerrar" (click)="closeDialog()">Cerrar</button>
</div>